<!-- filmpje -->
@if (hasMovie()) {
	<section class="o-wrapper" id="occupational-profile-movie">
		<div class="c-aan-het-woord" id="aan-het-woord">
			<h2>Een werknemer aan het woord</h2>
			<div class="c-profession-movie-box">
				<!-- The <iframe> (and video player) will replace this <div> tag. -->
				<div id="player" class="c-profession-movie"></div>
			</div>
		</div>
	</section>
}
